var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"ol-xs-12 mycol content-mb-14",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_PRIORITI_COMPLECT_AUTO'
      )
    }},[_c('Multiselect',{staticClass:"i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline",attrs:{"label":"NAME","limit":50,"limitText":_vm.filterItemText,"track-by":"ID","options":_vm.directory.sp_priority_components_auto,"multiple":true,"placeholder":""},model:{value:(_vm.project.UF_PRIORITI_COMPLECT_AUTO),callback:function ($$v) {_vm.$set(_vm.project, "UF_PRIORITI_COMPLECT_AUTO", $$v)},expression:"project.UF_PRIORITI_COMPLECT_AUTO"}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_PRIORITI_COMPLECT_AUTO"
        ))+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }